import Input from "../../component/ui/Input";
import {
  gamesSportOptions,
  playerFilter,
  sportPlayerData,
} from "../../helper/constant";
import SelectField from "../../component/ui/SelectField";
import { useEffect, useState } from "react";
import { ListFilter } from "lucide-react";
import DateAndTimePicker from "component/ui/Datepicker";
import Button from "component/ui/Button";
import { Link } from "react-router-dom";
import { MdOutlineMessage } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { getEventListV2 } from "store/slice/profile";
import LocationPicker from "component/ui/LocationPicker";

const CrewCard = () => {
  const [dropdown, setDropdown] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const handleDropdown = () => setDropdown((prev) => !prev);



  const dispatch = useDispatch();
  const [selectedSport, setSelectedSport] = useState(null);
  const [selectedClub, setSelectedClub] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [location, setLocation] = useState({
    address: "",
    latitude: null,
    longitude: null,
  });

  const { eventList } = useSelector((state) => state.profile);
  const clubs = eventList?.data || [];


  const getAddressFromCoords = async (lat, lng) => {
    if (!window.google || !window.google.maps) return "";

    return new Promise((resolve) => {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(
        { location: { lat, lng } },
        (results, status) => {
          if (status === "OK" && results?.length) {
            resolve(results[0].formatted_address);
          } else {
            resolve("");
          }
        }
      );
    });
  };


  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        setLocation((prev) => ({
          ...prev,
          latitude: lat,
          longitude: lng,
        }));

        // wait for Google Maps
        setTimeout(async () => {
          const address = await getAddressFromCoords(lat, lng);
          setLocation((prev) => ({
            ...prev,
            address,
          }));
        }, 500);
      },
      () => console.warn("GPS permission denied")
    );
  }, []);


  /* ================= LOCATION ================= */
  useEffect(() => {
    navigator.geolocation.getCurrentPosition((pos) => {
      setLocation({
        address: "",
        latitude: pos.coords.latitude,
        longitude: pos.coords.longitude,
      });
    });
  }, []);

  /* ================= FETCH CLUBS ================= */
  useEffect(() => {
    if (!location.latitude || !location.longitude) return;

    dispatch(
      getEventListV2(
        {
          language: "en",
          page: 1,
          perPage: 10,
          type: "club",
          category: selectedSport || null,
          latitude: location.latitude,
          longitude: location.longitude,
        },
        setLoading
      )
    );
  }, [selectedSport, location.latitude, location.longitude]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4">
      <div className="lg:max-w-5xl w-full mx-auto">
        {/* Header Section */}
        <div className="bg-white shadow-lg border border-gray-200 ">
          <div className="bg-gradient-to-r from-[#2BACE2] to-[#1a8ec4] px-8 py-4">
            <h2 className="text-2xl font-semibold text-white mb-2">
              Crew Cards
            </h2>
            <p className="text-blue-50 text-sm">Cards posted by Crew</p>
          </div>

          {/* Form Section */}
          <div className="space-y-6 p-6">
            {/* Sport and Location Row */}
            <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
              <div className="transform transition-all">
                <SelectField
                  label="Select Sport/Game"
                  placeholder="Select Sport/Game"
                  options={gamesSportOptions}
                  value={selectedSport}
                  onChange={setSelectedSport}
                />
              </div>

              <div className="relative flex items-center z-50 overflow-visible">
                <div className="w-[90%]">
                  <LocationPicker
                    label="Location"
                    placeholder="Search location"
                    value={location.address}
                    onChange={(place) => {
                      if (!place || !place.geometry) {
                        setLocation({
                          address: "",
                          latitude: null,
                          longitude: null,
                        });
                        return;
                      }

                      setLocation({
                        address: place.formatted_address || "",
                        latitude: place.geometry.location.lat(),
                        longitude: place.geometry.location.lng(),
                      });
                    }}
                  />
                </div>

                <ListFilter
                  onClick={handleDropdown}
                  className="w-[10%] mt-5 cursor-pointer text-highlight relative"
                />

                <div
                  className={`absolute top-full right-0 z-50 ${dropdown ? "block" : "hidden"
                    } bg-white rounded-lg shadow-lg w-40`}
                >
                  <ul className="py-2 text-sm text-white bg-gray-900 rounded-lg">
                    {playerFilter.map((item, index) => (
                      <li key={index}>
                        <button className="block w-full text-left px-4 py-2 hover:bg-[#2bace2]">
                          {item}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <DateAndTimePicker
                showDate
                dateLabel="Select Date"
                timeLabel="Select Time"
                placeholderDate="Select Date"
                placeholderTime="Select Time"
                isRequired
                inputClassName="w-full"
              />
            </div>

            {/* Players Section */}

            <div className="border-t border-gray-200 pt-4">
              <h3 className="text-xl font-semibold text-gray-800">
                Crew Cards
              </h3>
              <p className="text-sm text-gray-600 mt-1">
                {clubs.length} crew card
                {clubs.length !== 1 ? "s" : ""} available
              </p>
            </div>

            <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
              {clubs.map((player, index) => (
                <div
                  key={index}
                  className="group relative bg-gradient-to-br from-white to-gray-50 rounded-xl p-3 border border-gray-200 hover:border-[#2BACE2] hover:shadow-md transition-all duration-300 cursor-pointer"
                  onClick={() => setSelectedPlayer(player)} // Pass player details here
                >
                  <div className="flex items-center gap-4">
                    <div className="md:w-12 md:h-12 w-10 h-10 rounded-full bg-gradient-to-br from-[#2BACE2] to-[#1a8ec4] text-white flex items-center justify-center text-xl font-bold shadow-lg  transition-transform duration-300">
                      {player.initial}
                    </div>

                    <div className="flex-1 min-w-0">
                      <div className="flex gap-3 items-start">
                        <p className="text-base font-semibold text-gray-800 mb-1 truncate">
                          {player.name}
                        </p>
                        <p className="text-[10px] bg-highlight px-2 py-0.5 rounded-full  w-auto text-white">
                          LISTING
                        </p>
                      </div>
                      <div className="flex items-center justify-between align-center gap-2">
                        <p className="text-xs text-gray-600">
                          {player.sportName}
                        </p>
                        <div className="h-6 w-6 flex cursor-pointer justify-center items-center border-2 border-highlight rounded-full bg-[#2bace233]">
                          <MdOutlineMessage
                            className="h-3 w-3"
                            color="#2bace2"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </div>
      </div>
      {selectedPlayer && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-fadeIn">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#2BACE2] to-[#1a8ec4] px-6 py-4 flex items-center justify-between">
              <h3 className="text-lg font-semibold text-white">
                Player Details
              </h3>
              <button
                onClick={() => setSelectedPlayer(null)}
                className="text-white text-xl hover:opacity-80"
              >
                ✕
              </button>
            </div>

            {/* Content */}
            <div className="p-6 space-y-6 md:h-auto h-96 overflow-y-auto">
              {/* Player identity */}
              <div className="flex md:flex-row flex-col justify-between md:items-center md:gap-0 gap-2">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#2BACE2] to-[#1a8ec4] text-white flex items-center justify-center text-xl font-bold shadow-md shrink-0">
                    {selectedPlayer.initial}
                  </div>

                  <div className="">
                    <p
                      className="text-lg font-semibold text-gray-800 truncate max-w-[220px]"
                      title={selectedPlayer.name}
                    >
                      {selectedPlayer.name}
                    </p>
                    <p className="text-sm text-gray-500">
                      {selectedPlayer.sportName}
                    </p>
                  </div>
                </div>

                <div className="md:w-auto w-full flex justify-end">
                  <Button className="w-fit">View Profile</Button>
                </div>
              </div>

              {/* Details */}
              <div className="space-y-3 text-sm">
                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">Player ID</span>
                  <span
                    className="text-gray-800 max-w-[250px] truncate text-right"
                    title={selectedPlayer.id}
                  >
                    {selectedPlayer.id}
                  </span>
                </div>

                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">
                    Game / Sport
                  </span>
                  <span className="text-gray-800 text-right">
                    {selectedPlayer.sportName}
                  </span>
                </div>

                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">Skill Level</span>
                  <span className="text-gray-800 text-right">
                    {selectedPlayer.skillLevel}
                  </span>
                </div>

                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">
                    Achievements
                  </span>
                  <span
                    className="text-gray-800 text-right max-w-[250px] line-clamp-2"
                    title={selectedPlayer.achievement}
                  >
                    {selectedPlayer.achievement}
                  </span>
                </div>

                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">Location</span>
                  <Link
                    className="text-highlight underline max-w-[250px] line-clamp-2 text-right"
                    title={selectedPlayer.location}
                  >
                    {selectedPlayer.location || "N/A"}
                  </Link>
                </div>

                <div className="flex justify-between gap-3">
                  <span className="font-medium text-gray-500">Description</span>
                  <span
                    className="text-gray-800 text-right max-w-[250px] line-clamp-2"
                    title={selectedPlayer.description}
                  >
                    {selectedPlayer.achievement}
                  </span>
                </div>
              </div>
              <div className="flex justify-center">
                <Button>Send request</Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CrewCard;
